var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors;
  return {
    dotSize: '0.5rem',
    dotBackgroundColor: colors.slate
  };
};
export default generateComponentTheme;